module.exports = __webpack_public_path__ + "img/top-banner.32341e1c.png";